import { z } from "zod";

import { PRONOUNS } from "~/patients/constants/constants";
import { RELATIONSHIPS } from "~/patients/constants/relationships";

export const pronounOptionsSchema = z.enum(PRONOUNS);
export const relationshipOptionsSchema = z.enum(RELATIONSHIPS);
